/**
 * Static-translations for no. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const no = {
  'anon.heading_default': 'Fortsett som gjest',
  'anon.try_again': 'Prøv igjen',
  'auth.back_to_login': 'Tilbake til innlogging',
  'auth.check_email_message': 'Sjekk e-posten din — vi har sendt en bekreftelseskode.',
  'auth.check_email_title': 'Sjekk e-posten din',
  'auth.confirm_email_title': 'Bekreft e-posten din',
  'auth.confirmation_code': 'Bekreftelseskode',
  'auth.continue_with_apple': 'Fortsett med Apple',
  'auth.continue_with_facebook': 'Fortsett med Facebook',
  'auth.continue_with_github': 'Fortsett med GitHub',
  'auth.continue_with_google': 'Fortsett med Google',
  'auth.create_account': 'Opprett konto',
  'auth.default_subtitle': 'Logg inn for å få tilgang til alle funksjoner og synkronisere dataene dine.',
  'auth.email': 'E-postadresse',
  'auth.email_already_registered': 'Denne e-posten er allerede registrert. Logg inn nedenfor med passordet ditt eller kontoen du registrerte deg med.',
  'auth.email_exists': 'En konto med denne e-posten finnes allerede.',
  'auth.email_not_confirmed': 'Bekreft e-posten din først.',
  'auth.forgot_password': 'Glemt passord?',
  'auth.forgot_password_title': 'Glemt passord?',
  'auth.forgot_subtitle': 'Skriv inn e-posten din, så sender vi deg en lenke for å tilbakestille passordet.',
  'auth.generic_error': 'Noe gikk galt',
  'auth.have_account': 'Har du allerede en konto?',
  'auth.hide_password': 'Skjul passord',
  'auth.identity_already_linked': 'Denne kontoen er allerede registrert. Logg inn med den nedenfor.',
  'auth.invalid_credentials': 'Feil e-post eller passord',
  'auth.invalid_otp': 'Koden er ugyldig eller utløpt.',
  'auth.last_used': 'Sist brukt · {email}',
  'auth.last_used_no_email': 'Sist brukt',
  'auth.link_purchase_subheading': 'Vi knytter kjøpet til kontoen din for å beholde tilgangen.',
  'auth.log_in': 'Logg Inn',
  'auth.log_in_link': 'Logg Inn',
  'auth.login_continue_purchase': 'Logg inn for å fortsette kjøpet ditt',
  'auth.network_error': 'Nettverksfeil. Sjekk tilkoblingen og prøv igjen.',
  'auth.no_account': 'Har du ingen konto?',
  'auth.or': 'eller',
  'auth.password': 'Passord',
  'auth.passwords_mismatch': 'Passordene samsvarer ikke',
  'auth.rate_limited': 'For mange forespørsler. Prøv igjen senere.',
  'auth.repeat_password': 'Gjenta passord',
  'auth.reset_link_valid': 'Lenken er gyldig i 1 time.',
  'auth.reset_password_title': 'Tilbakestill passord',
  'auth.reset_sent_message': 'Hvis e-posten finnes, er det sendt en tilbakestillingskode.',
  'auth.reset_sent_subtitle': 'Vi har sendt en lenke for å tilbakestille passordet. Følg instruksjonene i e-posten.',
  'auth.restore_purchases_heading': 'Gjenopprett Kjøp',
  'auth.restore_purchases_subheading': 'Logg inn for å gjenopprette kjøpene dine.',
  'auth.send_reset': 'Send Tilbakestillingsmail',
  'auth.service_unavailable': 'Tjenesten er midlertidig utilgjengelig. Prøv igjen senere.',
  'auth.show_password': 'Vis passord',
  'auth.sign_out': 'Logg ut',
  'auth.sign_up': 'Registrer',
  'auth.sign_up_link': 'Registrer',
  'auth.signed_in': 'Logget inn',
  'auth.signin_failed': 'Pålogging mislyktes',
  'auth.signup_failed': 'Registrering mislyktes',
  'auth.verify': 'Bekreft',
  'auth.weak_password': 'Passordet er for svakt.',
  'auth.welcome': 'Velkommen!',
  'auth.welcome_signup': 'Velkommen!',
  'cta.close': 'Lukk',
  'cta.continue': 'Fortsett',
  'cta.get_lifetime_access': 'Få livstidstilgang',
  'cta.get_plan_daily': 'Få daglig plan',
  'cta.get_plan_monthly': 'Få månedlig plan',
  'cta.get_plan_weekly': 'Få ukentlig plan',
  'cta.get_plan_yearly': 'Få årlig plan',
  'cta.start_trial': 'Start {days} Dagers Gratis Prøveperiode',
  'modal.close_aria': 'Lukk',
  'modal.continue': 'Fortsett',
  'modal.error_generic': 'Noe gikk galt',
  'modal.loading': 'Laster…',
  'modal.purchase_restored_subtitle': 'Alt er klart — kos deg!',
  'modal.purchase_restored_title': 'Velkommen tilbake',
  'modal.purchase_success_subtitle': 'Alt er klart — kos deg!',
  'modal.purchase_success_title': 'Betaling mottatt',
  'modal.verifying_subscription': 'Sjekker abonnementet…',
  'nav.back': '← Tilbake',
  'nav.back_aria': 'Tilbake',
  'offer.limited_time': 'Tidsbegrenset tilbud',
  'payment.awaiting_title': 'Fullfør betalingen i den nye fanen',
  'payment.checking': 'Sjekker…',
  'payment.ive_paid': 'Jeg har betalt',
  'payment.open_checkout_again': 'Åpne betaling igjen',
  'payment.open_checkout_button': 'Åpne betaling',
  'pricing.free_trial_days': '{days}-dagers gratis prøveperiode',
  'pricing.included_per': 'Inkludert per {interval}:',
  'pricing.interval.day': 'dag',
  'pricing.interval.lifetime_short': 'livstid',
  'pricing.interval.month': 'måned',
  'pricing.interval.period': 'periode',
  'pricing.interval.week': 'uke',
  'pricing.interval.year': 'år',
  'pricing.money_back': '30 dagers pengene-tilbake-garanti',
  'pricing.most_popular': 'Mest populær',
  'pricing.no_prices': 'Ingen priser tilgjengelig.',
  'pricing.plan_label.daily': 'DAGLIG PLAN',
  'pricing.plan_label.lifetime': 'livstid',
  'pricing.plan_label.monthly': 'månedlig plan',
  'pricing.plan_label.weekly': 'ukentlig plan',
  'pricing.plan_label.yearly': 'årlig plan',
  'pricing.plans_aria': 'Planer',
  'session.contact_support': 'Kontakt support',
  'session.restore_purchases': 'Gjenopprett kjøp',
  'session.sign_out': 'Logg ut',
  'session.signed_in_as_prefix': 'Logget inn som',
  'session.signing_out': 'Logger ut…',
  'support.attachments_label': 'Vedlegg',
  'support.close_button': 'Lukk',
  'support.done_button': 'Ferdig',
  'support.email_placeholder': 'Skriv inn e-posten din',
  'support.heading': 'Støtte',
  'support.instruction': 'Vennligst fyll ut skjemaet nedenfor for å sende inn støtteforespørselen din.',
  'support.invalid_email': 'Ugyldig e-post',
  'support.message_length': '1–5000 tegn',
  'support.message_placeholder': 'Skriv inn meldingen din',
  'support.required': 'Påkrevd',
  'support.send_another': 'Send en ny forespørsel',
  'support.send_button': 'Send',
  'support.sending': 'Sender…',
  'support.subject_length': '3–200 tegn',
  'support.subject_placeholder': 'Skriv inn emnet ditt',
  'support.success_heading': 'Forespørsel sendt',
  'support.success_message_prefix': 'Vi har mottatt meldingen din og vil svare på'
} as const;

export default no;
